// Getters
export const overview = (state) => {
  return state.overview.data || []
}
export const overviewLoading = (state) => {
  return state.overview.loading
}
export const overviewLastUpdate = (state) => {
  return state.overview.lastUpdate
}


export const meses = (state) => {
  return state.meses.data || []
}
export const mesesLoading = (state) => {
  return state.meses.loading
}
export const mesesLastUpdate = (state) => {
  return state.meses.lastUpdate
}

export const btgDisponivel = (state) => {
  return state.btg ? state.btg.disponivel : null
}
export const btgEstornoHabilitado = (state) => {
  return Boolean(state.btg && state.btg.estornoHabilitado)
}
export const btgSaldos = (state) => {
  return (state.btg && state.btg.saldos) || {}
}
export const btgSaldosConsultadoEm = (state) => {
  return (state.btg && state.btg.saldosConsultadoEm) || null
}
export const btgConexao = (state) => {
  return (state.btg && state.btg.conexao) || null
}
export const btgOperacoes = (state) => {
  return (state.btg && state.btg.operacoes) || {}
}
